
import {
    FETCH_ADMIN_USERS_REQUEST,
    FETCH_ADMIN_USERS_SUCCESS,
    FETCH_ADMIN_USERS_FAILURE,
    ADD_ADMIN_USER_REQUEST,
    ADD_ADMIN_USER_SUCCESS,
    ADD_ADMIN_USER_FAILURE,
    DELETE_ADMIN_USER_REQUEST,
    DELETE_ADMIN_USER_SUCCESS,
    DELETE_ADMIN_USER_FAILURE,
    CLEAR_ADMIN_USER_ERROR
} from '../actions';

const initialState = {
    isLoading: false,
    error: '',
    adminUsers: []
};

const adminUserReducer = ((state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADMIN_USERS_REQUEST:
            return { ...state, isLoading: true, error: '' };
        case FETCH_ADMIN_USERS_SUCCESS:
            return { ...state, adminUsers: action.payload, isLoading: false, error: '' };
        case FETCH_ADMIN_USERS_FAILURE:
            return { ...state, isLoading: false, error: action.payload };
        case ADD_ADMIN_USER_REQUEST:
            return { ...state, isLoading: true, error: '' };
        case ADD_ADMIN_USER_SUCCESS:
            return { ...state, adminUsers: [...state.adminUsers, action.payload], isLoading: false, error: '' };
        case ADD_ADMIN_USER_FAILURE:
            return { ...state, isLoading: false, error: action.payload };
        case DELETE_ADMIN_USER_REQUEST:
            return { ...state, isLoading: true, error: '' };
        case DELETE_ADMIN_USER_SUCCESS:
            return { ...state, adminUsers: state.adminUsers.filter(u => u._id !== action.payload), isLoading: false, error: '' };
        case DELETE_ADMIN_USER_FAILURE:
            return { ...state, isLoading: false, error: action.payload };
        case CLEAR_ADMIN_USER_ERROR:
            return { ...state, error: '' };
        default:
            return state;
    }
});

export default adminUserReducer;
